export default __webpack_public_path__ + "static/media/hiding-octopus.24476385.png";